import ContextMenu from './ContextMenu';

export default {
  __init__: [ 'contextMenu' ],
  contextMenu: [ 'type', ContextMenu ]
};